import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import axios from "axios";
import addLogDocument from "../addLogDocument";
import JSZip from "jszip"; // Ensure the zip library is imported
import {
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getRefFromId,
} from "../../models/DataFunctions";
import createDocApi from "../database/createDocApi";
import { addActivityLog } from "../../config/OnlineStatus";

const extractXml = async (
  url,
  type,
  token,
  orgId,
  folderId,
  phone,
  oid,
  email,
  address,
  name,
  prefix,
  orgData,
  new_model = false,
  modif_thermal = false
) => {
  try {
    const start = new Date();

    // Download file
    const response = await axios.get(url, { responseType: "arraybuffer" });
    if (response.status !== 200)
      throw new Error(`Failed to download file: ${response.status}`);

    // Extract XML content from ZIP
    const zip = await JSZip.loadAsync(response.data);
    const xmlContent = await processZipBytes(zip);
    if (!xmlContent) throw new Error("No XML file found in the ZIP archive");

    // Prepare formData for upload
    const extractUrl = `${prefix}folders/${folderId}/xml/extract`;
    const formData = new FormData();
    formData.append("file", new Blob([xmlContent]), "extracted.xml");
    if (type === "carbon" || type === "both") {
      formData.append("type", type);

      // POST formData
      const extractResponse = await axios.post(extractUrl, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (extractResponse.status !== 200)
        throw new Error("XML extraction failed");

      // Process response
      const jsonResponse = extractResponse.data;

      const list = jsonResponse.items.map((item) => {
        return {
          X: item.index,
          num: item.sous_lot,
          nom: item.nom,
          id: item.identifiant,
          qt: item.quantité,
          un: item.unité,
        };
      });
      return { list };
    } else {
      const pdfUrl = `${prefix}folders/${folderId}/xml/generate_pdf`;

      const user = getAuthCentral().currentUser;
      const userRef = doc(getFirestore(), "user", user.uid);
      const folderRef = getRefFromId("folder", folderId);
      await addActivityLog(
        "Extraction XML",
        folderRef,
        orgId,
        userRef.id,
        "xml_extraction",
        prefix
      );
      const logo =
        orgData.config?.ath?.hide_my_logo === true
          ? null
          : orgData.logo || "https://i.ibb.co/8Nc2tS4/Placeholder.png";
      const pdfBody = {
        footer: `${name} - ${address}\nTéléphone : ${phone} - Mail : ${email}`,
        type,
        oid,
        logo: logo,
        new_model,
      };
      formData.append("request", JSON.stringify(pdfBody));
      formData.append("modif_thermal", modif_thermal);

      const pdfResponse = await axios.post(pdfUrl, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (pdfResponse.status === 200) {
        // convert to JSON
        const pdfData = pdfResponse.data;
        const url = pdfData.url.trim().replace(/"/g, "");
        const sign_coords = pdfData.sign_coords;
        // get url and sign_coords from dict

        return { list: [], sign_coords: sign_coords };
      } else {
        console.error("PDF generation failed:", pdfResponse.status);
        return { list: [], sign_coords: [] };
      }
    }
  } catch (error) {
    console.error("Error in extractXml:", error.message);
    return { list: [], sign_coords: [] };
  }
};

export const processZipBytes = async (zip) => {
  for (const filename in zip.files) {
    if (filename.endsWith(".xml") && !filename.includes("/")) {
      return await zip.file(filename).async("string");
    }
  }
  return null;
};

export default extractXml;
